const DEFAULT_BASE_URL = 'http://localhost:8084/rest';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || DEFAULT_BASE_URL;

/** When false, repositories fall back to local mock data where implemented. */
export const USE_API = process.env.REACT_APP_USE_API !== 'false';

export const TOKEN_KEYS = {
  access: 'utkarsh_access_token',
  refresh: 'utkarsh_refresh_token',
  staff: 'utkarsh_auth_staff',
  permissions: 'utkarsh_auth_permissions',
  isSuperAdmin: 'utkarsh_auth_is_super_admin',
};
